<h2 mat-dialog-title>Financial Adviser Details</h2>

<mat-dialog-content class="mat-typography">
    <form [formGroup]="formGroup">
        <section class="change-strategy">
            <div class="form-field-wrapper mb-1">
                <mat-label>Financial Adviser Name</mat-label>
                <mat-form-field appearance="outline" class="small" subscriptSizing="dynamic">
                    <input matInput formControlName="wealthCoachName" />
                    <mat-error *ngIf="formGroup.get('wealthCoachName')?.hasError('required') && formGroup.get('wealthCoachName')?.touched">
                        Financial Adviser Name is required.
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="form-field-wrapper mb-1" *ngIf="this.dialogData.isShowPreviousSOA || this.dialogData.isShowCallofDate">
                <mat-label>Email</mat-label>
                <mat-form-field appearance="outline" class="small" subscriptSizing="dynamic">
                    <input matInput  type="email" formControlName="email" />
                    <mat-error *ngIf="formGroup.get('email')?.hasError('required') && formGroup.get('email')?.touched">
                        email is required.
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="form-field-wrapper mb-1">
                <mat-label>AR Number</mat-label>
                <mat-form-field appearance="outline" class="small" subscriptSizing="dynamic">
                    <input matInput formControlName="arNumber" />
                    <mat-error *ngIf="formGroup.get('arNumber')?.hasError('required') && formGroup.get('arNumber')?.touched">
                        AR Number is required.
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="form-field-wrapper mb-1" *ngIf="this.dialogData.isShowCallofDate">
                <mat-label>Date ROA sent</mat-label>
                <mat-form-field appearance="outline" class="small" subscriptSizing="dynamic">
                    <input matInput [matDatepicker]="pickerCallOfDate" formControlName="dateOfCall" required />
                    <mat-datepicker-toggle matIconSuffix [for]="pickerCallOfDate"></mat-datepicker-toggle>
                    <mat-datepicker #pickerCallOfDate></mat-datepicker>
                    <mat-error *ngIf="formGroup.get('dateOfCall')?.hasError('required') && formGroup.get('dateOfCall')?.touched">
                        Date ROA sent is required.
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="form-field-wrapper mb-1" *ngIf="dialogData.isShowPreviousSOA">
                <mat-label>Statement of Advice date</mat-label>
                <mat-form-field appearance="outline" class="small" subscriptSizing="dynamic">
                    <input matInput [matDatepicker]="pickerPreviousStatement" formControlName="dateOfPreviousSOA" required />
                    <mat-datepicker-toggle matIconSuffix [for]="pickerPreviousStatement"></mat-datepicker-toggle>
                    <mat-datepicker #pickerPreviousStatement></mat-datepicker>
                    <mat-error *ngIf="formGroup.get('dateOfPreviousSOA')?.hasError('required') && formGroup.get('dateOfPreviousSOA')?.touched">
                        Statement of Advice date is required.
                    </mat-error>
                </mat-form-field>
            </div>
        </section>
    </form>
</mat-dialog-content>

<mat-dialog-actions [align]="'end'">
    <div class="footer">
        <button mat-stroked-button mat-dialog-close class="w-150">Cancel</button>

        <button mat-raised-button color="primary" class="w-150" (click)="confirm()">Confirm</button>
    </div>
</mat-dialog-actions>
